(() => {
  const SLIDE_SEL = 'slideshow-slide:has([class*="image_cervelo_logo"])';
  const REVEAL_SEL = 'slideshow-slide:has([class*="image_cervelo_logo_reveal"])';
  const LOGO_SEL = '[class*="image_cervelo_logo"]';
  const TYPE_MS = 80;
  const SCRIBBLE_MS = 1450;
  const END_MS = 3200;
  const DIM = "rgba(8, 14, 10, 0.58)";
  const CARD_HTML =
    '<div class="zc-dealer-card" aria-hidden="true">' +
    '<canvas class="zc-dealer-veil" aria-hidden="true"></canvas>' +
    '<p class="zc-dealer-card__title">Now an official dealer</p>' +
    "</div>";

  function reduceMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function asVw(value, fallback) {
    const raw = String(value || "").trim();
    if (raw.endsWith("vw")) return raw;
    const n = parseFloat(raw);
    return Number.isFinite(n) ? `${n}vw` : fallback;
  }

  function sync(slide) {
    const logo = slide.querySelector(LOGO_SEL);
    if (!logo) return;
    const cs = getComputedStyle(logo);
    slide.style.setProperty("--zc-logo-pct", asVw(cs.getPropertyValue("--size-style-width"), "46vw"));
    slide.style.setProperty("--zc-logo-pct-mobile", asVw(cs.getPropertyValue("--size-style-width-mobile"), "54vw"));
    const width = logo.getBoundingClientRect().width;
    if (width > 0) slide.style.setProperty("--zc-logo-w", `${Math.round(width)}px`);
    const img = logo.querySelector("img");
    if (img?.naturalWidth && img.naturalHeight) {
      const ratio = img.naturalWidth / img.naturalHeight;
      logo.style.setProperty("--ratio", String(ratio));
      img.style.setProperty("--ratio", String(ratio));
    }
  }

  function cardState(slide) {
    if (!slide._zcCard) slide._zcCard = {};
    return slide._zcCard;
  }

  function clearTimers(state) {
    clearTimeout(state.inTimer);
    clearTimeout(state.scribbleTimer);
    clearTimeout(state.endTimer);
    if (state.raf) cancelAnimationFrame(state.raf);
    state.raf = 0;
  }

  function scribblePath(w, h) {
    const pts = [];
    const add = (fn, steps) => {
      for (let i = 0; i <= steps; i++) pts.push(fn(i / steps));
    };
    add((t) => ({
      x: w * (-0.04 + t * 1.1),
      y: h * (0.2 + Math.sin(t * Math.PI) * 0.17 + t * 0.1),
    }), 26);
    add((t) => ({
      x: w * (1.06 - t * 1.12),
      y: h * (0.46 + Math.sin(t * Math.PI * 1.05) * 0.14),
    }), 28);
    add((t) => ({
      x: w * (-0.05 + t * 1.12),
      y: h * (0.7 + Math.cos(t * Math.PI) * 0.12),
    }), 24);
    return pts;
  }

  function paintDim(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    const dpr = Math.max(1, window.devicePixelRatio || 1);
    const w = canvas.clientWidth;
    const h = canvas.clientHeight;
    if (w < 2 || h < 2) return null;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = "source-over";
    ctx.globalAlpha = 1;
    ctx.fillStyle = DIM;
    ctx.fillRect(0, 0, w, h);
    canvas.style.opacity = "1";
    canvas.style.transition = "none";
    return ctx;
  }

  function runScribble(slide, canvas) {
    const ctx = paintDim(canvas);
    if (!ctx) return;
    const w = canvas.clientWidth;
    const h = canvas.clientHeight;
    const pts = scribblePath(w, h);
    const r = Math.min(w, h) * 0.19;
    let i = 0;
    const state = cardState(slide);

    const stamp = () => {
      if (slide.getAttribute("aria-hidden") === "true") return;
      if (i >= pts.length) {
        canvas.style.transition = "opacity 0.55s cubic-bezier(0.16, 1, 0.3, 1)";
        canvas.style.opacity = "0";
        return;
      }
      const p = pts[i++];
      const g = ctx.createRadialGradient(p.x, p.y, r * 0.06, p.x, p.y, r);
      g.addColorStop(0, "rgba(0,0,0,0.92)");
      g.addColorStop(0.35, "rgba(0,0,0,0.38)");
      g.addColorStop(1, "rgba(0,0,0,0)");
      ctx.globalCompositeOperation = "destination-out";
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
      ctx.fill();
      state.raf = requestAnimationFrame(stamp);
    };
    state.raf = requestAnimationFrame(stamp);
  }

  function playReveal(slide) {
    const card = slide.querySelector(".zc-dealer-card");
    const canvas = slide.querySelector(".zc-dealer-veil");
    if (!card || !canvas) return;
    const state = cardState(slide);
    clearTimers(state);
    card.classList.remove("is-in", "is-scribbling", "is-open", "is-playing");
    slide.classList.remove("zc-reveal-open", "zc-reveal-playing");
    slide.querySelector(".zc-dealer-iris")?.remove();

    if (reduceMotion()) {
      slide.classList.add("zc-reveal-open");
      return;
    }

    paintDim(canvas);
    card.classList.add("is-playing");

    state.inTimer = setTimeout(() => {
      card.classList.add("is-in");
    }, TYPE_MS);

    state.scribbleTimer = setTimeout(() => {
      card.classList.add("is-scribbling");
      card.classList.remove("is-in");
      runScribble(slide, canvas);
    }, SCRIBBLE_MS);

    state.endTimer = setTimeout(() => {
      card.classList.add("is-open");
      slide.classList.add("zc-reveal-open", "zc-reveal-playing");
    }, END_MS);
  }

  function resetReveal(slide) {
    const state = cardState(slide);
    clearTimers(state);
    slide.classList.remove("zc-reveal-open", "zc-reveal-playing");
    const card = slide.querySelector(".zc-dealer-card");
    const canvas = slide.querySelector(".zc-dealer-veil");
    if (!card) return;
    card.classList.remove("is-in", "is-scribbling", "is-open", "is-playing");
    if (canvas) paintDim(canvas);
  }

  function bindReveal(slide) {
    if (slide.dataset.zcRevealBound === "1") return;
    slide.dataset.zcRevealBound = "1";
    slide.querySelector(".zc-dealer-foil")?.remove();
    slide.querySelector(".zc-dealer-iris")?.remove();
    if (!slide.querySelector(".zc-dealer-card")) {
      slide.insertAdjacentHTML("beforeend", CARD_HTML);
    }

    const canvas = slide.querySelector(".zc-dealer-veil");
    if (canvas) {
      const ro = new ResizeObserver(() => {
        if (slide.getAttribute("aria-hidden") === "true") return;
        if (slide.classList.contains("zc-reveal-open")) return;
        if (slide.querySelector(".zc-dealer-card")?.classList.contains("is-scribbling")) return;
        paintDim(canvas);
      });
      ro.observe(slide);
    }

    const watch = () => {
      if (slide.getAttribute("aria-hidden") === "true") resetReveal(slide);
      else playReveal(slide);
    };

    new MutationObserver(watch).observe(slide, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
    watch();
  }

  function bind(slide) {
    if (slide.dataset.zcDealerBound === "1") return;
    slide.dataset.zcDealerBound = "1";
    const logo = slide.querySelector(LOGO_SEL);
    if (!logo) return;
    const ro = new ResizeObserver(() => sync(slide));
    ro.observe(logo);
    const img = logo.querySelector("img");
    if (img && !img.complete) img.addEventListener("load", () => sync(slide), { once: true });
    sync(slide);
  }

  function scan() {
    document.querySelectorAll(SLIDE_SEL).forEach(bind);
    document.querySelectorAll(REVEAL_SEL).forEach(bindReveal);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  document.addEventListener("shopify:section:load", scan);
  document.addEventListener("shopify:section:reorder", scan);
  document.addEventListener("shopify:block:select", scan);
})();
